const YesNoMaybe = {
  Yes: 'Yes',
  No: 'No',
  Maybe: 'Maybe',
} as const;

export const YesNoMaybeConst = {
  YesNoMaybe,
} as const;
